<template>
  <div class="bg-gray-100">
    <div class="min-vh-100">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <AutomationListTable
        v-if="showAutomationListTable"
        :automationList="automationListData"
        :pagination="automationListPagination"
        :isLoadingTable="isLoadingAutomationList"
        @updatePage="handleUpdatePage"
        @searchFilter="handleSearchFilter"
        @stateSelect="handleStateFilter"
        @changeSort="handleSortChange"
        @refreshTable="getAutomationList"
      />
      <AutomationListEmpty v-else />
    </div>
  </div>
</template>

<script>
import AutomationListEmpty from '../components/AutomationListEmpty.vue'
import AutomationListTable from '../components/AutomationListTable.vue'
import AutomationSMSContent from '../components/AutomationSMSContent.vue'
import AutomationEmailContent from '../components/AutomationEmailContent.vue'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services'
import { getErrorMessage } from '@/utils/errorHandling.js'
import { STATE_TYPES } from '../constants'

export default {
  name: 'AutomationList',
  components: { AutomationListEmpty, AutomationListTable, AutomationSMSContent, AutomationEmailContent, MenssageAlert },
  data() {
    return {
      messages: [],
      automationListResponse: undefined,
      isLoadingAutomationList: false,
      automationListPagination: {
        itemsPerPage: 10,
        page: 1,
      },
      automationListFilters: {
        sortField: {
          order: 'descending',
          column: 'updatedDateTime',
        },
      },
      STATE_TYPES: STATE_TYPES,
      processingAutomationInterval: undefined,
    }
  },
  async mounted() {
    await this.getAutomationList()
    this.handleProcessingAutomations()
  },
  beforeDestroy() {
    clearInterval(this.processingAutomationInterval)
  },
  methods: {
    handleProcessingAutomations() {
      if (!this.hasPendingAutomations) return
      
      this.processingAutomationInterval = setInterval(async () => {
        const isSilentRefresh = true
        await this.getAutomationList(isSilentRefresh)
      }, 3500)
    },
    handleUpdatePage(page) {
      this.automationListPagination.page = page
      this.getAutomationList()
    },
    handleSearchFilter(filter) {
      this.automationListPagination.page = 1
      this.$set(this.automationListFilters, 'name', filter)
      this.getAutomationList()
    },
    handleStateFilter(selectOpt) {
      if (selectOpt.value !== 0) {
        this.$set(this.automationListFilters, 'status', selectOpt.value)
      } else {
        this.$set(this.automationListFilters, 'status', undefined)
      }
      this.getAutomationList()
    },
    handleSortChange(sortState) {
      const orderValue = sortState.asc ? 'ascending' : 'descending'
      this.$set(this.automationListFilters.sortField, 'order', orderValue)
      this.$set(this.automationListFilters.sortField, 'column', sortState.column)
      this.getAutomationList()
    },
    async getAutomationList(isSilentRefresh) {
      try {
        if (!isSilentRefresh) {
          this.isLoadingAutomationList = true
        }

        const params = {
          Name: this.automationListFilters?.name,
          Status: this.automationListFilters?.status,
          Page: this.automationListPagination?.page,
          Count: this.automationListPagination?.itemsPerPage,
          Sort: this.automationListFilters?.sortField?.order,
          SortField: this.automationListFilters?.sortField?.column,
        }

        const response = await services.getAutomations(this.$route.params.organizationId, params)

        this.automationListResponse = response
        this.automationListPagination = {
          ...this.automationListPagination,
          ...response.data.data.pagination,
        }
      } catch (error) {
        this.messages = [getErrorMessage(error?.response?.data)]
      } finally {
        if (!isSilentRefresh) {
          this.isLoadingAutomationList = false
        }
      }
    },
  },
  computed: {
    hasPendingAutomations() {
      return this.automationListData.some((automation) => automation.workflowStatus == this.STATE_TYPES.PENDING_CAMPAIGN_CREATION)
    },
    hasAutomationListResponse() {
      if (!this.automationListResponse) return false
      return this.automationListResponse.data.data.pagination.totalRecords > 0
    },
    hasAnyAutomationListFilter() {
      return Boolean(this.automationListFilters?.status) || Boolean(this.automationListFilters?.name)
    },
    automationListData() {
      const automationListData = this.automationListResponse?.data?.data?.workflows

      if (!automationListData) return []

      return automationListData
    },
    showAutomationListTable() {
      return this.hasAutomationListResponse || this.isLoadingAutomationList || this.hasAnyAutomationListFilter
    },
  },
  watch: {
    hasPendingAutomations() {
      if (!this.hasPendingAutomations) {
        clearInterval(this.processingAutomationInterval)
      }
    }
  }
}
</script>
